import React from "react";
import tokenService from "../../../../Common/tokenDecoder";
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Paper from '@material-ui/core/Paper';
import { TableRow } from "@material-ui/core";
import moment from "moment";

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const reportData = this.props.data;
        const totalAmount = this.props.totalAmount;

        return (
            <div>
                <h3><center><u>Weighment Details Report</u></center></h3>
                <div className="row pb-4 pt-4 pl-2">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Factory: </b> {searchData.factory}</div>
                    <div className="col"><b>Route: </b> {searchData.route === undefined ? "All Routes" : searchData.route}</div>
                    <div className="col"><b>From Date: </b> {searchData.fromDate}</div>
                    <div className="col"><b>To Date: </b> {searchData.toDate}</div>
                    <div className="col"><b>User: </b> {tokenService.getUserNameFromToken()}</div>
                    <div className="col"><b>Date/Time: </b> {new Date().toLocaleString()}</div>
                </div>

                <div>
                    <div className="card pt-2 pl-3 pr-3" style={{ width: "10rem;" }}>
                    </div>
                    <div className="row">
                        <TableContainer component={Paper}>
                            <Table aria-label="simple table" size='small'>
                                <TableHead>
                                    <TableRow >
                                        <TableCell align="left" style={{ fontWeight: "bold", border: "1px solid black" }}>Date</TableCell>
                                        <TableCell align="left" style={{ fontWeight: "bold", border: "1px solid black" }}>Route Name</TableCell>
                                        <TableCell align="left" style={{ fontWeight: "bold", border: "1px solid black" }}>Registration Number</TableCell>
                                        <TableCell align="left" style={{ fontWeight: "bold", border: "1px solid black" }}>Supplier Name</TableCell>
                                        <TableCell align="left" style={{ fontWeight: "bold", border: "1px solid black" }}>First Weighment Time</TableCell>
                                        <TableCell align="left" style={{ fontWeight: "bold", border: "1px solid black" }}>Last Weighment Time</TableCell>
                                        <TableCell align="right" style={{ fontWeight: "bold", border: "1px solid black" }}>Total</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {reportData.map((x, i) => (
                                        <TableRow key={i}>
                                            <TableCell component="th" scope="row" align="left" style={{ border: "1px solid black" }}> {moment(x.date).format('YYYY-MM-DD')}</TableCell>
                                            <TableCell component="th" scope="row" align="left" style={{ border: "1px solid black" }}> {x.collectionPointName}</TableCell>
                                            <TableCell component="th" scope="row" align="left" style={{ border: "1px solid black" }}> {x.registrationNumber}</TableCell>
                                            <TableCell component="th" scope="row" align="left" style={{ border: "1px solid black" }}> {x.firstName}</TableCell>
                                            <TableCell component="th" scope="row" align="left" style={{ border: "1px solid black" }}> {(x.startTime)}</TableCell>
                                            <TableCell component="th" scope="row" align="left" style={{ border: "1px solid black" }}> {(x.endTime)}</TableCell>
                                            <TableCell component="th" scope="row" align="right" style={{ border: "1px solid black" }}> {(x.totalAmount).toFixed(2)}</TableCell>
                                        </TableRow>
                                    ))}
                                    <TableRow>
                                        <TableCell colSpan={6} component="th" scope="row" align="left" style={{ border: "1px solid black" }}>Total</TableCell>
                                        <TableCell component="th" scope="row" align="right" style={{ border: "1px solid black" }}> {(totalAmount).toFixed(2)}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>

                </div>
            </div>
        );
    }
}